






































































































































import { InputType, ButtonType, ParagraphSize } from '@getaccept/lib-ui';
import { sanitizeEmail, validateEmail } from '@getaccept/lib-shared/src/helpers';
import { LocalStorageKey } from '@getaccept/lib-shared/src/enums/local-storage';
import { LocalStorageHelper } from '@getaccept/lib-shared/src/helpers/local-storage.helper';
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from '@vue/composition-api';
import GoogleIcon from '../assets/google.svg';
import LinkedInIcon from '../assets/linkedin.svg';
import VerifyEmail from '../assets/verify-email/VerifyEmail.svg';
import { PathChecker } from '../../helpers/path-checker';
import { LoginProvider } from '../types/enums/login-provider';
import { useLogin } from '../composable/login.composable';
import i18n from '../../i18n/lang';
import router from '../../router/router';
import SSO from './SSO.vue';

export default defineComponent({
  components: {
    GoogleIcon,
    LinkedInIcon,
    VerifyEmail,
    SSO,
  },
  setup() {
    const { login, error, launchIdentifier, loading } = useLogin();

    const password = ref('');
    const passwordError = ref('');
    const viewPassword = ref(false);

    watch(password, () => {
      passwordError.value = '';
    });

    const passwordInputType = computed(() =>
      viewPassword.value ? InputType.Text : InputType.Password
    );

    const toggleViewPassword = () => {
      viewPassword.value = !viewPassword.value;
    };

    const validatePassword = (password: string) => {
      if (!password) {
        return i18n.t('password-is-required').toString();
      }
      return '';
    };

    const validateEmailAddress = (email: string): string => {
      if (!email) {
        return i18n.t('email-is-required').toString();
      } else if (!validateEmail(sanitizeEmail(email))) {
        return i18n.t('enter-a-valid-email').toString();
      }
      return '';
    };

    const showVerifyEmail = ref(false);
    const email = ref('');
    const emailError = ref('');

    watch(email, () => {
      emailError.value = '';
    });

    const verificationEmail = computed(() =>
      LocalStorageHelper.getLocalStorage(LocalStorageKey.VerificationEmail)
    );

    const showSso = ref(false);
    const toggleShowSso = (show: boolean) => {
      showSso.value = show;
    };

    const handleProviderClick = (provider: LoginProvider) => {
      launchIdentifier(provider);
    };

    const handleSubmit = () => {
      const cleanEmail = sanitizeEmail(email.value);
      passwordError.value = validatePassword(password.value);
      emailError.value = validateEmailAddress(cleanEmail);
      if (passwordError.value || emailError.value) {
        return;
      }
      login({ email: cleanEmail, password: password.value });
    };

    onMounted(() => {
      showVerifyEmail.value = PathChecker.checkLoginVerifyEmailPaths(router.currentRoute.path);
    });

    onBeforeUnmount(() => {
      LocalStorageHelper.reset(LocalStorageKey.VerificationEmail);
    });

    return {
      email,
      password,
      passwordError,
      emailError,
      viewPassword,
      showVerifyEmail,
      showSso,
      passwordInputType,
      verificationEmail,
      toggleShowSso,
      toggleViewPassword,
      error,
      handleSubmit,
      LoginProvider,
      ButtonType,
      ParagraphSize,
      handleProviderClick,
      loading,
      validatePassword,
      validateEmailAddress,
    };
  },
});
